module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('link', {
    attrs: {
      "href": "https://fonts.googleapis.com/icon?family=Material+Icons",
      "rel": "stylesheet"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-bar text-center mcBG"
  }, [_c('img', {
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("uManage Mobile" + _vm._s(_vm.sandboxTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_c('h2', {
    staticClass: "scText"
  }, [_vm._v("Image Upload")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Tap or Click to take a picture or choose one from your files.")]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": "https://umanagemobile.s3.amazonaws.com",
      "preview-template": _vm.template
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "key",
      "value": "${filename}"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "acl",
      "value": "public-read"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "X-Amz-Credential",
      "value": "AKIAJUCRBPCVPXUQRPMA/20171004/us-east-2/s3/aws4_request"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "X-Amz-Algorithm",
      "value": "AWS4-HMAC-SHA256"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "X-Amz-Date",
      "value": "20171004T165244Z"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Policy",
      "value": "eyJleHBpcmF0aW9uIjoiMjAxNy0xMC0xMFQwOjUyOjQ0WiIsImNvbmRpdGlvbnMiOlt7ImFjbCI6InB1YmxpYy1yZWFkIn0seyJidWNrZXQiOiJ1bWFuYWdlbW9iaWxlIn0seyJzdWNjZXNzX2FjdGlvbl9yZWRpcmVjdCI6Imh0dHA6XC9cL2xvY2FsaG9zdFwvcmVBU1wvQVdTXC8ifSxbInN0YXJ0cy13aXRoIiwiJGtleSIsIiJdLFsiY29udGVudC1sZW5ndGgtcmFuZ2UiLCIxIiwiMjA5NzE1MiJdLHsieC1hbXotY3JlZGVudGlhbCI6IkFLSUFKVUNSQlBDVlBYVVFSUE1BXC8yMDE3MTAwNFwvdXMtZWFzdC0yXC9zM1wvYXdzNF9yZXF1ZXN0In0seyJ4LWFtei1hbGdvcml0aG0iOiJBV1M0LUhNQUMtU0hBMjU2In0seyJYLWFtei1kYXRlIjoiMjAxNzEwMDRUMTY1MjQ0WiJ9XX0="
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "X-Amz-Signature",
      "value": "74ba2a5dfe80cf5e73c7e665f309943dc8e37426f453435d3cf71c8033531cac"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "success_action_redirect",
      "value": "http://localhost/reAS/AWS/"
    }
  })])], 1)]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("        " + _vm._s(_vm.$data) + "\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d6eb054!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dev.vue
// module id = 861
// module chunks = 2